import fp from 'lodash/fp';
import * as constants from './constants';
import * as actions from './actions';

export const INITIAL_STATE = {
    defaultFilters: constants.defaultFilters,
    filterDefinitions: constants.filterDefinitions,
    productClassData: {},
    fetchingProductClassData: {},
    fetchingProductClassError: {},

    initialised: false,
    loading: false,
    currentServerFilters: []
};

const setInitialised = fp.set('initialised');
const setLoading = fp.set('loading');

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_INITIALISED:
            return setInitialised(action.initialised, state);
        case actions.SET_LOADING:
            return setLoading(action.loading, state);
        case actions.FETCH_PRODUCT_CLASS_REQUEST:
            return fp.flow(
                fp.set(`fetchingProductClassData.${action.productClass}`, true),
                fp.omit(`fetchingProductClassError.${action.productClass}`)
            )(state);
        case actions.FETCH_PRODUCT_CLASS_SUCCESS:
            return fp.flow(
                fp.set(`productClassData.${action.productClass}`, action.data),
                fp.set('currentServerFilters', action.serverFilters),
                fp.omit(`fetchingProductClassData.${action.productClass}`),
                fp.omit(`fetchingProductClassError.${action.productClass}`)
            )(state);
        case actions.FETCH_PRODUCT_CLASS_ERROR:
            return fp.flow(
                fp.omit(`productClassData.${action.productClass}`),
                fp.omit(`fetchingProductClassData.${action.productClass}`),
                fp.set(`fetchingProductClassError.${action.productClass}`, action.message)
            )(state);
        default:
            return state;
    }
}
